import ContractsIcon from '@mui/icons-material/TaskOutlined';
import ProvisionIcon from '@mui/icons-material/Inventory2Outlined';
import React, {useEffect, useState} from 'react';
import SidebarListItem from './SidebarListItem';
import {Collapse, List, styled} from '@mui/material';
import {Routes} from '@account/utils/route';
import {lightGrey} from '@account/styles';
import {useFlags} from '@hooks/useFlags';

const StyledList = styled(List)({borderBottom: `solid 1px ${lightGrey}`});

const PVSidebar = () => {
  const [open, setOpen] = useState(false);

  const {oneClickProvisioningIsActive} = useFlags();

  useEffect(() => setOpen(true), [setOpen]);

  return (
    <Collapse in={open}>
      <StyledList disablePadding>
        <SidebarListItem
          text={oneClickProvisioningIsActive ? 'To Do' : 'Provision'}
          to={Routes.CONTRACTS}
          id="pv-contract-review"
          icon={<ProvisionIcon color="disabled" fontSize="small" />}
          exact
          nested
        />

        <SidebarListItem
          text={oneClickProvisioningIsActive ? 'Complete' : 'Contracts'}
          to={Routes.CONTRACTS_ALL}
          id="pv-all-contracts"
          icon={<ContractsIcon color="disabled" fontSize="small" />}
          exact
          nested
        />
      </StyledList>
    </Collapse>
  );
};

export default PVSidebar;
